import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { languages } from '../../../../configs/language'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { Panel } from '../../../common/panel'
import { formatText, formatVal, valToPercent } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import { EMPTY_VALUE } from '../../../utils/common'
import { LabelPanel } from '../common/LabelPanel'
import { RightPanel } from '../common/RightPanel'
import { selectCompanyInfo } from '../store/slice'
import classes from './index.module.scss'

export const ChangeLimitScore = ({ data, detailKey }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const { organizationId } = useSelector(selectCompanyInfo)

  const detailData = data[detailKey]

  const formatCurrency = (value) => {
    const formattedValue = formatVal(value, locale, false, 0)
    if (formattedValue === EMPTY_VALUE) return EMPTY_VALUE
    return locale === languages.en
      ? `VND ${formattedValue}`
      : `${formattedValue} VND`
  }

  return (
    <Panel
      renderLabel={() => <LabelPanel data={data} detailData={detailData} />}
      renderRightHeader={() => <RightPanel data={data} detailKey={detailKey} />}
    >
      <Element className={classes.description} style={{ fontSize: 14 }}>
        {formatText(detailData?.description)}
      </Element>
      <Element
        className={classes.content}
        style={{ fontSize: 14, color: '#3A414B' }}
      >
        <Element
          className={classes.contentItem}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <div>
            <Translate value="alertDetail.PREVIOUS" className="textUppercase" />
          </div>
          <div className={classes.mt12}>
            {formatCurrency(detailData?.previous)}
          </div>
        </Element>
        <Element
          className={classes.contentItem}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <div className="dFlex alignItemsCenter justifyContentCenter">
            <span className="mr1">
              <Translate
                value="alertDetail.CURRENT"
                className="textUppercase"
              />
            </span>
            <Icon
              className={
                detailData.percentage >= 0
                  ? 'icon-arrow-up-circle'
                  : 'icon-arrow-down-circle'
              }
              style={{
                fontSize: 18,
                color: detailData.percentage >= 0 ? '#3DA967' : '#E0505B',
                marginRight: 4,
              }}
            />
            <span>{valToPercent(detailData.percentage, locale)}</span>
          </div>
          <div className={classes.mt12}>
            {formatCurrency(detailData?.current)}
          </div>
        </Element>
      </Element>
      <Element className={classes.source} style={{ color: '#3A414B' }}>
        <div>
          <Element elementName="span" style={{ color: '#2C73E8' }}>
            <Link
              to={`${COMPONENTS.companyAnalysis.components.score.components.corporateRiskScore.route}?organizationId=${organizationId}`}
              target="_blank"
            >
              <Translate value="alertDetail.CLICK_HERE" />
            </Link>
          </Element>
          &nbsp;
          <Translate value="alertDetail.FOR_MORE_INFORMATION" />
        </div>
      </Element>
    </Panel>
  )
}
